import urlConfig from "../../config.json";
import { BACKEND_URL } from "../../constants";
import { axios } from "../../utils/axiosConfig";
import { handleApiError } from "../scopedListFetch";

export const getPropertyDetails = async (propertyId) => {
  const ROUTE = urlConfig.backend.routes.properties.getPropertyDetails;
  const url = `${BACKEND_URL}${ROUTE}`;

  return await axios
    .get(url, {
      params: { id: propertyId },
    })
    .then((res) => {
      if (res.status === 200) {
        return { res: res.data, error_code: 1 };
      }
      return {
        error_code: 2,
        error_message: "Something Went Wrong please try again later",
      };
    })
    .catch((error) => handleApiError(error));
};
